// web/src/api/consent.ts
//
// Typed wrapper for POST /api/v1/me/consent. Posted at signup
// (SignupForm) and post-OAuth (ConfirmHandler) to record clickwrap
// acceptance against LATEST_LEGAL_VERSION.
import { apiFetch } from "./client";

export async function recordConsent(tosVersion: string): Promise<void> {
  await apiFetch<void>("/api/v1/me/consent", {
    method: "POST",
    body: JSON.stringify({ tos_version: tosVersion }),
  });
}
